import ButtonFunction from '../shared/ButtonFunction';
import {motion} from 'framer-motion';
import Card from "../shared/Card";
import GeneralContext from '../../context/GeneralContext';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Welcome() {

  const { userName, changeUserMenu, logout } = useContext(GeneralContext);

  const navigate = useNavigate();

  const logoutFunction = () => {
    logout();
    navigate('/');
  }

  useEffect(() => {
    console.log(userName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div
      key='userWelcome'
      initial={{opacity: 0, x: -1000}}
      animate={{opacity: 1, x: 0}}
      exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
      transition={{duration: 0.5}}>
        <Card>
            <h1>Te damos la bienvenida, {userName}</h1>
            <ButtonFunction
              buttonFunction={changeUserMenu}
              buttonArguments={'reset'}
              buttonClass='loginButton'
            >
              Restablecer contraseña
            </ButtonFunction>
            <br />
            <br />
            <ButtonFunction
              buttonFunction={logoutFunction}
              buttonClass='loginButton'
            >
              Cerrar sesión
            </ButtonFunction>
        </Card>
      </motion.div>
  )
}

export default Welcome